// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export enum NewNetTraderMode {
    LoginMode = 'LM',
    WorkMode = 'WM',
    ReloginMode = 'RM'
};
